<template>
	<div>

	</div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {
    let login_token = this.$route.query.token;
    window.location.href = window.location.origin + '/customer/action/login/verifyLogin?url=' + window.location.origin + '/tjkStudy/voiceSceneIndex&token='+login_token
  },
  methods: {
  	
  } 
}
</script>


// WEBPACK FOOTER //
// ./src/page/voiceScene/blankLogin.vue